import { render, staticRenderFns } from "./gradeSlider.vue?vue&type=template&id=0945fb4f&scoped=true&"
import script from "./gradeSlider.vue?vue&type=script&lang=js&"
export * from "./gradeSlider.vue?vue&type=script&lang=js&"
import style0 from "./gradeSlider.vue?vue&type=style&index=0&id=0945fb4f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0945fb4f",
  null
  
)

/* custom blocks */
import block0 from "./gradeSlider.vue?vue&type=custom&index=0&blockType=comment"
if (typeof block0 === 'function') block0(component)

export default component.exports